import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as DeleteIcon } from '../../assets/svg/DeleteIcon.svg';
import { DragDropContext } from 'react-beautiful-dnd';
import { Droppable } from 'react-beautiful-dnd';
import { Draggable } from 'react-beautiful-dnd';
import { getImage } from '../../server/server-media';
import AddFileFromLibraryModal from './AddFileFromLibraryModal';
import SingleImageModal from './SingleImageModal';

function ImagesForm({ imagesList, setImagesList }: { imagesList: any; setImagesList: any }) {
	const [libraryModalOpen, setLibraryModalOpen] = useState(false);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [selectedPicture, setSelectedPicture] = useState<any>(null);

	const closeModal = () => {
		setSelectedPicture(null);
		setModalIsOpen(false);
	};

	const openSingleImageModal = (item: any) => {
		setSelectedPicture(item);
		setModalIsOpen(true);
	};

	const removeImageFromList = (index: number) => {
		if (window.confirm('Do you want to remove image from list?')) {
			let newList = [...imagesList];
			newList.splice(index, 1);
			let newReorderList = newList.map((item, index) => {
				return { ...item, redosled: index + 1 };
			});
			setImagesList(newReorderList);
			//setProduct({ ...product, files: newReorderList });
		}
	};

	const closeLibraryModal = () => {
		setLibraryModalOpen(false);
	};

	const handleDrop = (droppedItem: any) => {
		// Ignore drop outside droppable container
		if (!droppedItem.destination) return;
		var updatedList = [...imagesList];
		// Remove dragged item
		const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
		// Add dropped item
		updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
		let newReorderList = updatedList.map((item, index) => {
			return { ...item, redosled: index + 1 };
		});
		setImagesList(newReorderList);
	};

	const handleSelectedFile = (id: any) => {
		setImagesList([...imagesList, { id: id, redosled: imagesList.length + 1 }]);
		closeLibraryModal();
	};

	return (
		<div className='flex  w-full flex-col mt-6 border border-mediumGrey rounded-md p-2 gap-5 '>
			<div className=' w-full  '>
				<div className='flex  h-full  flex-col  w-full '>
					<div className='flex w-full flex-row items-center gap-5'>
						<p className='text-darkGrey text-xl flex-1'>Lista dodatih slika </p>
						<Button variant='contained' onClick={() => setLibraryModalOpen(true)} style={{ backgroundColor: '#2ec4b6', color: 'white' }}>
							Dodaj sliku iz galerije
						</Button>
					</div>
					<div className=' mt-3 max-h-[330px] overflow-auto gray-small-scroll pb-[15px] pr-2'>
						{!!imagesList.length && (
							<div className='grid grid-cols-6 gap-1 p-[6px]'>
								<p className='text-darkGrey text-lg'>Pozicija</p>
								<p className='col-span-5 text-darkGrey text-lg'>Slika</p>
							</div>
						)}
						<DragDropContext onDragEnd={handleDrop}>
							<Droppable droppableId='list-container'>
								{(provided) => (
									<div {...provided.droppableProps} ref={provided.innerRef}>
										{imagesList
											?.sort((a: any, b: any) => a.redosled - b.redosled)
											.map((item: any, index: number) => {
												return (
													<Draggable key={index.toString()} draggableId={index.toString()} index={index}>
														{(provided) => (
															<div
																className='grid grid-cols-6 gap-1 bg-white transition-colors hover:bg-babyBlue  border border-mediumGrey mt-1 p-[6px]'
																ref={provided.innerRef}
																{...provided.draggableProps}
															>
																<div className='flex flex-row items-center pl-4' {...provided.dragHandleProps}>
																	{index + 1}
																</div>
																<div className='flex flex-row items-center justify-between col-span-5 '>
																	<img
																		src={getImage(item.id)}
																		alt='product'
																		style={{ minHeight: 60, maxHeight: 60, aspectRatio: '1/1', objectFit: 'cover', objectPosition: 'top', cursor: 'pointer' }}
																		onClick={() => openSingleImageModal(item)}
																	/>
																	<div className='cursor-pointer mr-5' onClick={() => removeImageFromList(index)}>
																		<DeleteIcon />
																	</div>
																</div>
															</div>
														)}
													</Draggable>
												);
											})}
										{provided.placeholder}
									</div>
								)}
							</Droppable>
						</DragDropContext>
					</div>
				</div>
			</div>
			<AddFileFromLibraryModal modalIsOpen={libraryModalOpen} closeModal={closeLibraryModal} returnSelectedFile={handleSelectedFile} />
			<SingleImageModal modalIsOpen={modalIsOpen} closeModal={closeModal} selectedPicture={selectedPicture} deleteFlag={false} />
		</div>
	);
}

export default ImagesForm;
